import React from 'react'
import { FormattedMessage } from 'react-intl'

export const UNIT_MATCHING = (
    <FormattedMessage
        id='battleRooms.tab.players_matching.unit_matching'
        defaultMessage='Подбор отряда...'
    />
)

export const WAITING_BATTLES_START = (
    <FormattedMessage
        id='battleRooms.tab.players_matching.waiting_battles_start'
        defaultMessage='Ожидание начала боёв...'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/constants.js